import React from 'react';

const Pagination = ({ postsPerPage, totalPosts, currentPage, onPageChange }) => {
    const totalPages = Math.max(1, Math.ceil(totalPosts / postsPerPage));
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    // اگر نیاز نیست در صفحات تک صفحه‌ای چیزی نمایش داده شود:
    if (totalPages === 1) return null;

    const goTo = (page) => {
        const p = Math.max(1, Math.min(totalPages, page));
        if (typeof onPageChange === "function") onPageChange(p);
    };

    return (
        <ul className='flex flex-row-reverse items-center justify-center my-8 py-4 rounded bg-primary-100'>
            <li
                onClick={() => goTo(currentPage - 1)}
                className={`mx-2 px-3 py-1 rounded-lg 
                    ${currentPage === 1
                        ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
                        : 'bg-white text-slate-500 cursor-pointer hover:bg-slate-100'
                    }`}
            >
                قبل
            </li>

            {pageNumbers.map(number => (
                <li
                    key={number}
                    onClick={() => goTo(number)}
                    className={`cursor-pointer m-2 px-3 py-1 rounded font-IRANSansXFaNumMedium
                        ${currentPage === number ? 'bg-primary-500 text-white' : 'bg-slate-300 text-slate-500 hover:bg-slate-200'}`}
                >
                    {number}
                </li>
            ))}

            <li
                onClick={() => goTo(currentPage + 1)}
                className={`mx-2 px-3 py-1 rounded-lg 
                    ${currentPage === totalPages
                        ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
                        : 'bg-white text-slate-500 cursor-pointer hover:bg-slate-100'
                    }`}
            >
                بعد
            </li>
        </ul>
    );
};

export default Pagination;